import React from "react";
import { Link } from "react-router-dom";
import { Container } from 'semantic-ui-react'

const NavTop = (props) => {
	const { options, restaurant } = window;

	return (
		<div id="NavTop">
			<Container>
				<div className="logo">
					{ restaurant.settings.restaurant_website === null && (<Link to="/"><img src="https://gastrocv.com/img/GP-logo.png" title="GastroPlanner" alt="GastroPlanner" /></Link>)}
					{ restaurant.settings.restaurant_website !== null && (<a href={restaurant.settings.restaurant_website} target="_blank"><img src="https://gastrocv.com/img/GP-logo.png" title="GastroPlanner" alt="GastroPlanner" /></a>)}
				</div>
				<div className="change-language">
					{ options.lang !== "en" && <a href={`/${window.options.base_url}?locale=en`}>English</a> }
					{ options.lang !== "no" && <a href={`/${window.options.base_url}?locale=no`}>Norsk</a> }
				</div>
			</Container>
		</div>
	);
}

export default NavTop;


// WEBPACK FOOTER //
// ./src/components/ui/NavTop.js